import { isCreditCard } from 'validator';

import {
  addressProperties,
  addressRequired,
  customValidate
} from 'common/components/address/validators';
import { validateForUI } from 'common/helpers/jsonValidator';

const loggedInCustomer = () => {
  const schema = {
    type: 'object',
    properties: addressProperties,
    required: addressRequired,
    additionalProperties: false
  };
  schema.properties.customerAddressId = { type: 'string' };
  return schema;
};

const notLoggedInCustomer = () => {
  const schema = {
    type: 'object',
    properties: addressProperties,
    required: addressRequired,
    additionalProperties: false
  };
  return schema;
};

const creditCardSchema = {
  type: 'object',
  properties: {
    cardNumber: { type: 'string' },
    expiryMo: { type: 'integer', minimum: 1, maximum: 12 },
    expiryYr: { type: 'integer', minimum: 2018 },
    cvv2: { type: 'string', maxLength: 4 },
    cardHolderName: { type: 'string' }
  },
  required: ['cardNumber', 'expiryMo', 'expiryYr', 'cvv2', 'cardHolderName'],
  additionalProperties: false
};

export const validateAddressForLoggedInCustomer = (address, settings) => {
  const errors = validateForUI(
    loggedInCustomer(),
    address,
    customValidate(address, 'billing', settings)
  );
  return errors;
};

export const validateAddressForNotLoggedInCustomer = (address, settings) => {
  const errors = validateForUI(
    notLoggedInCustomer(),
    address,
    customValidate(address, 'billing', settings)
  );
  return errors;
};

export const validateCreditCard = (creditCard) => {
  const errors = validateForUI(
    creditCardSchema,
    creditCard,
    customValidateCC(creditCard)
  );
  return errors;
};

const customValidateCC = (creditCard) => {
  const errorArray = [];
  if (creditCard.cardNumber && !isCreditCard(creditCard.cardNumber)) {
    errorArray.push({
      field: 'cardNumber',
      message: 'Invalid credit card number'
    });
  }

  // validate exiry number is in the future
  if (
    creditCard.expiryYr < new Date().getFullYear() ||
    (creditCard.expiryYr === new Date().getFullYear() &&
      creditCard.expiryMo < new Date().getMonth() + 1)
  ) {
    errorArray.push({ field: 'expiryMo', message: 'Invalid expiry date' });
    errorArray.push({ field: 'expiryYr', message: 'Invalid expiry date' });
  }

  return errorArray;
};
